import {
    DIVISIONLISTAGENTFORPARTNER_SUCCESS,
    DIVISIONLISTAGENTFORPARTNER_FAILED,
    RESET_DIVISIONLISTAGENTFORPARTNER,
    LOADING_DIVISIONLISTAGENTFORPARTNER,
    NETWORK_ERROR_DIVISIONLISTAGENTFORPARTNER
} from "../types/index";

import { partnerServices } from "../../config/axios";


const resetDivisionListAgentForPartner = () => {
    return { type: RESET_DIVISIONLISTAGENTFORPARTNER };
};

const partnerDivisionListReq = (userData, authTokenIs) => async (dispatch) => {
    dispatch({ type: LOADING_DIVISIONLISTAGENTFORPARTNER });
    await partnerServices
        .post("divisionList", userData, { headers: { AuthToken: authTokenIs } })
        .then((res) => {
            switch (res.data.status) {
                case "success":
                    dispatch(partnerDivisionListReqsuccess(res.data));
                    break;
                default:
                    dispatch(partnerDivisionListReqFailed(res.data));
                    break;
            }
        })
        .catch((err) => {
            dispatch({
                type: NETWORK_ERROR_DIVISIONLISTAGENTFORPARTNER,
                payload: err
            });
        });
};

function partnerDivisionListReqsuccess(data) {
    return {
        type: DIVISIONLISTAGENTFORPARTNER_SUCCESS,
        payload: data,
    };
}

function partnerDivisionListReqFailed(data) {
    return {
        type: DIVISIONLISTAGENTFORPARTNER_FAILED,
        payload: data,
    };
}

export { resetDivisionListAgentForPartner, partnerDivisionListReq }